import { render, staticRenderFns } from "./FitnessActivityPage.vue?vue&type=template&id=6d98d2c1&scoped=true"
import script from "./FitnessActivityPage.vue?vue&type=script&lang=ts"
export * from "./FitnessActivityPage.vue?vue&type=script&lang=ts"
import style0 from "./FitnessActivityPage.vue?vue&type=style&index=0&id=6d98d2c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d98d2c1",
  null
  
)

export default component.exports